import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import '../styles/DocsUpload.css';

// Set up axios defaults
axios.defaults.withCredentials = true;
axios.defaults.headers.common['x-api-key'] = process.env.REACT_APP_CREATE_USER_API_KEY;

// Create an axios instance for file uploads
const fileUploadAxios = axios.create({
  withCredentials: true,
  headers: {
    'x-api-key': process.env.REACT_APP_CREATE_USER_API_KEY,
    'Accept': 'multipart/form-data'  // Add this line
  }
});

const InitiativeDocsUpload = () => {
  const [formData, setFormData] = useState({
    title: '',
    authors: '',
    document_type: 'core_philosophy',
    primary_category: 'marketing_philosophy',
    sub_categories: '',
    confidentiality_level: 'public'
  });
  
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState({ loading: false, error: null, success: false, processing: false });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, error: null, success: false, processing: false });
    
    try {
      const submitData = new FormData();
      Object.keys(formData).forEach((key) => submitData.append(key, formData[key]));
      
      if (file) {
        submitData.append('fileInput', file);
      }

      const response = await axios.post(
        'https://n8n.iniai.cloud/webhook/upload-ini-docs', 
        submitData
      );

      setStatus({ 
        loading: false, 
        error: null, 
        success: true,
        processing: true 
      });

      // Reset form
      setFormData({
        title: '',
        authors: '',
        document_type: 'core_philosophy',
        primary_category: 'marketing_philosophy',
        sub_categories: '',
        confidentiality_level: 'public'
      });
      setFile(null);
      
    } catch (error) {
      setStatus({ 
        loading: false, 
        error: error.message || 'Something went wrong', 
        success: false,
        processing: false
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    if (e.target.files?.[0]) {
      const selectedFile = e.target.files[0];
      console.log('Selected file size:', selectedFile.size / 1024 / 1024, 'MB');
      
      if (selectedFile.size > 45 * 1024 * 1024) { // 45MB limit
        setStatus({
          loading: false,
          error: 'File size must be less than 45MB',
          success: false,
          processing: false
        });
        return;
      }
      setFile(selectedFile);
    }
  };

  return (
    <div className="form-container">
      <h2 className="form-title">Initiative Documents Upload</h2>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Document Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
            className="form-input"
            placeholder="Enter document title"
          />
        </div>

        <div class="form-group">
          <label className="form-label">
            Authors (comma-separated)
          </label>
          <input
            type="text"
            name="authors"
            value={formData.authors}
            onChange={handleChange}
            required
            className="form-input"
            placeholder="Enter authors"
          />
        </div>

        <div class="form-group">
          <label className="form-label">
            Document Type
          </label>
          <select
            name="document_type"
            value={formData.document_type}
            onChange={handleChange}
            className="form-input"
          >
            <option value="core_philosophy">Core Philosophy</option>
            <option value="case_study">Case Study</option>
            <option value="methodology">Methodology</option>
            <option value="framework">Framework</option>
          </select>
        </div>

        <div class="form-group">
          <label className="form-label">
            Primary Category
          </label>
          <select
            name="primary_category"
            value={formData.primary_category}
            onChange={handleChange}
            className="form-input"
          >
            <option value="marketing_philosophy">Marketing Philosophy</option>
            <option value="case_study">Case Study</option>
            <option value="technical_guide">Technical Guide</option>
            <option value="research">Research</option>
          </select>
        </div>

        <div class="form-group">
          <label className="form-label">
            Sub-categories (comma-separated)
          </label>
          <input
            type="text"
            name="sub_categories"
            value={formData.sub_categories}
            onChange={handleChange}
            className="form-input"
            placeholder="Enter sub-categories"
          />
        </div>

        <div class="form-group">
          <label className="form-label">
            Confidentiality Level
          </label>
          <select
            name="confidentiality_level"
            value={formData.confidentiality_level}
            onChange={handleChange}
            className="form-input"
          >
            <option value="public">Public</option>
            <option value="internal">Internal Only</option>
            <option value="confidential">Confidential</option>
          </select>
        </div>

        <div class="form-group">
          <label className="form-label">
            Document File
          </label>
          <input
            type="file"
            name="fileInput"
            onChange={handleFileChange}
            required
            className="form-input"
            accept=".pdf,.doc,.docx"
          />
        </div>

        {status.error && (
          <div className="form-error">
            {status.error}
          </div>
        )}

        {status.success && (
          <div className="form-success">
            {status.processing 
              ? 'Document uploaded successfully! Processing may take up to 20 minutes.'
              : 'Document uploaded and processed successfully!'}
          </div>
        )}

        <button
          type="submit"
          disabled={status.loading || !file}
          className={`form-submit
            ${(status.loading || !file)
              ? 'bg-gray-400 cursor-not-allowed' 
              : 'bg-blue-600 hover:bg-blue-700 transition-colors'
            }`}
        >
          {status.loading ? 'Uploading...' : 'Upload Document'}
        </button>
      </form>
    </div>
  );
};

export default InitiativeDocsUpload;


